(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-product"]) return;
  try {
    
if (!customElements.get('french-story-stock')) {
  customElements.define('french-story-stock', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.selector = this.closest('form')?.querySelector('[data-variant-selector]');
      const options = { signal: this.controller.signal };
      this.selector?.addEventListener('change', () => { this.hidden = true; this.refreshStock(); }, options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.refreshStock();
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.refreshStock();
      }, options);
      this.timer = window.setInterval(() => {
        if (!document.hidden) this.refreshStock();
      }, 60000);
    }
    disconnectedCallback() {
      this.controller?.abort();
      window.clearInterval(this.timer);
    }
    async refreshStock() {
      if (this.refreshing || !this.isConnected || !this.selector) return;
      this.refreshing = true;
      const variantId = this.selector.value;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('variant', variantId);
        const response = await fetch(url, { cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) throw new Error('Stock unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('french-story-stock');
        if (!fresh) throw new Error('Stock unavailable');
        if (!this.isConnected || this.selector.value !== variantId) return;
        this.hidden = fresh.hidden;
        this.dataset.lowStock = fresh.dataset.lowStock;
        const copy = this.querySelector('[data-stock-copy]');
        const nextCopy = fresh.querySelector('[data-stock-copy]').textContent;
        if (copy.textContent !== nextCopy) copy.textContent = nextCopy;
        const freshSelect = fresh.closest('form').querySelector('[data-variant-selector]');
        const freshOption = [...freshSelect.options].find(option => option.value === variantId);
        const option = this.selector.selectedOptions[0];
        if (freshOption && option) {
          option.dataset.available = freshOption.dataset.available;
          option.dataset.max = freshOption.dataset.max;
          const section = this.closest('[data-product-section]');
          const add = section.querySelector('[data-add-button]');
          add.disabled = option.dataset.available !== 'true';
          add.textContent = add.disabled ? add.dataset.soldOut : add.dataset.add;
          const sticky = section.querySelector('[data-sticky-add]');
          if (sticky) { sticky.disabled = add.disabled; sticky.textContent = add.textContent; }
          const quantity = section.querySelector('[name="quantity"]');
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = Math.max(1, Math.min(Number(quantity.value) || 1, Number(quantity.max) || Infinity));
        }
      } catch (error) {
        if (this.isConnected && error.name !== 'AbortError') this.hidden = true;
      } finally {
        this.refreshing = false;
        if (this.isConnected && this.selector?.value !== variantId) this.refreshStock();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
